import * as React from 'react';
import { IndexRedirect, Route } from 'react-router';
import { makeGetComponent } from './utils';

export const getSubscribeRoute = () => (
  <Route path="subscribe" getComponent={makeGetComponent('PublicPage')}>
    <IndexRedirect to="intro" />
    {/* Disabled on May 18th 2020 because these credit pages where unused. */}
    {/* <Route
      path="intro"
      getComponent={makeGetComponent('DataSubscriptionPage')}
    /> */}
    {/* <Route
      path="select"
      getComponent={makeGetComponent('DataSubscriptionSelectPage')}
    /> */}
    {/* <Route
      path="payment"
      getComponent={makeGetComponent('DataSubscriptionPaymentPage')}
    /> */}
    {/* <Route
      path="assign"
      getComponent={makeGetComponent('DataSubscriptionAssignPage')}
    /> */}
    {/* <Route path="credit" getComponent={makeGetComponent('DataPaymentPage')} /> */}
    <Route
      path="checkout"
      getComponent={makeGetComponent(
        'DataPaymentPage/DataPaymentPageContainer'
      )}
    />
    {/* For payments made for admin subscription requests */}
    <Route
      path="subscriptions/payment"
      getComponent={makeGetComponent(
        'Admin/SubscriptionRequests/PaymentPage/PaymentPageContainer'
      )}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/SubscribeRoute.tsx